var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTutor(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.1667 11.0416C13.5424 11.0416 13.9027 10.8924 14.1684 10.6267C14.4341 10.361 14.5833 10.0007 14.5833 9.62496V1.83329C14.5833 1.45757 14.4341 1.09723 14.1684 0.831558C13.9027 0.565881 13.5424 0.416626 13.1667 0.416626H5.70083C5.94875 0.848709 6.08333 1.33746 6.08333 1.83329H13.1667V9.62496H6.79167V11.0416H13.1667ZM9.625 3.95829V5.37496H5.375V14.5833H3.95833V10.3333H2.54167V14.5833H1.125V8.91663H0.0625V5.37496C0.0625 4.99924 0.211755 4.6389 0.477432 4.37322C0.743109 4.10755 1.10344 3.95829 1.47917 3.95829H9.625ZM4.66667 1.83329C4.66667 2.20902 4.51741 2.56935 4.25173 2.83503C3.98606 3.1007 3.62572 3.24996 3.25 3.24996C2.87428 3.24996 2.51394 3.1007 2.24827 2.83503C1.98259 2.56935 1.83333 2.20902 1.83333 1.83329C1.83333 1.45757 1.98259 1.09723 2.24827 0.831558C2.51394 0.565881 2.87428 0.416626 3.25 0.416626C3.62572 0.416626 3.98606 0.565881 4.25173 0.831558C4.51741 1.09723 4.66667 1.45757 4.66667 1.83329Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTutor);
export default __webpack_public_path__ + "static/media/tutor.b287df0e.svg";
export { ForwardRef as ReactComponent };